import React from 'react';
import { motion } from 'framer-motion';
import { Map, LineChart, Briefcase, ShieldCheck } from 'lucide-react';
const bonuses = [{
  icon: Map,
  title: 'The 12-Minute Visual Action Map',
  value: '$17',
  desc: 'A beautifully designed, print-ready poster showing every step of the nightly sequence in visual, illustrated format. Place it beside your bed. No need to open the book every night.'
}, {
  icon: LineChart,
  title: 'The 3-Day Relief Tracker',
  value: '$9.87',
  desc: 'A simple, powerful daily tracking sheet that measures your pain score before and after each session — so you can SEE your progress in real numbers.'
}, {
  icon: Briefcase,
  title: 'The Desk-Side Mini Reset',
  value: '$9.87',
  desc: "A 2-minute seated version of the protocol designed for your office, your car, or anywhere your back flares up during the day. Because pain doesn't wait for bedtime."
}];
export function BonusStack() {
  return <section className="py-24 px-6 bg-navy-800 border-y border-navy-700" data-id="element-218">
      <div className="max-w-4xl mx-auto" data-id="element-219">
        <div className="text-center mb-16" data-id="element-220">
          <h2 className="text-4xl md:text-5xl font-serif text-cream mb-4" data-id="element-221">
            Plus — 3 Free Bonuses Worth{' '}
            <span className="line-through text-cream-300/50" data-id="element-222">$36.74</span>
          </h2>
          <p className="text-xl text-teal-400 font-medium" data-id="element-223">
            Included free when you order today.
          </p>
        </div>

        <div className="space-y-6" data-id="element-224">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-900 border border-navy-700 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-start" data-id="element-225">
              <div className="w-16 h-16 shrink-0 bg-gradient-to-br from-gold-500/20 to-gold-600/5 rounded-2xl flex items-center justify-center text-gold-500 border border-gold-500/20" data-id="element-226">
                <bonus.icon className="w-8 h-8" data-id="element-227" />
              </div>
              <div className="flex-1" data-id="element-228">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-229">
                  <span className="text-gold-500 font-bold tracking-widest uppercase text-sm" data-id="element-230">
                    Bonus #{i + 1}
                  </span>
                  <h3 className="text-xl md:text-2xl font-serif text-cream" data-id="element-231">
                    {bonus.title}
                  </h3>
                </div>
                <div className="flex items-center gap-3 mb-4" data-id="element-232">
                  <span className="text-cream-300/50 line-through text-sm" data-id="element-233">
                    Value: {bonus.value}
                  </span>
                  <span className="bg-teal-500/20 text-teal-400 text-xs font-bold px-2 py-1 rounded uppercase tracking-wider" data-id="element-234">
                    Yours Free
                  </span>
                </div>
                <p className="text-cream-300/80 leading-relaxed" data-id="element-235">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export function ValueStack() {
  return <section className="py-24 px-6 bg-navy-900" data-id="element-236">
      <div className="max-w-3xl mx-auto" data-id="element-237">
        <div className="bg-navy-800 border border-teal-500/30 rounded-3xl overflow-hidden shadow-2xl" data-id="element-238">
          <div className="bg-teal-500/10 py-6 text-center border-b border-teal-500/20" data-id="element-239">
            <h3 className="text-2xl font-serif text-cream" data-id="element-240">
              The Complete Value Stack
            </h3>
          </div>

          <div className="p-8 space-y-4" data-id="element-241">
            <div className="flex justify-between items-center py-3 border-b border-navy-700" data-id="element-242">
              <span className="text-cream font-medium" data-id="element-243">
                The 11PM Spine Reset — Complete Guide
              </span>
              <span className="text-cream-300/70" data-id="element-244">$6.39</span>
            </div>
            {bonuses.map((b, i) => <div key={i} className="flex justify-between items-center py-3 border-b border-navy-700" data-id="element-245">
                <span className="text-cream-300/80" data-id="element-246">
                  Bonus #{i + 1}: {b.title.replace('The ', '')}
                </span>
                <span className="text-cream-300/70" data-id="element-247">{b.value}</span>
              </div>)}

            <div className="pt-8 pb-4 text-center space-y-2" data-id="element-248">
              <p className="text-lg text-cream-300/60 uppercase tracking-widest" data-id="element-249">
                Total Value
              </p>
              <p className="text-3xl font-serif text-cream-300/40 line-through decoration-red-500/50" data-id="element-250">
                $43.13
              </p>
            </div>

            <div className="bg-teal-500/10 rounded-xl p-6 text-center border border-teal-500/30 mb-8" data-id="element-251">
              <p className="text-sm text-teal-400 uppercase tracking-widest font-bold mb-2" data-id="element-252">
                Your Price Today
              </p>
              <p className="text-6xl font-serif text-cream font-bold" data-id="element-253">$6.39</p>
            </div>

            <a href="#final-cta" className="block w-full text-center bg-teal-500 hover:bg-teal-400 text-navy-900 font-bold text-xl py-5 px-8 rounded-xl shadow-[0_0_30px_rgba(20,184,166,0.2)] transition-all transform hover:-translate-y-1" data-id="element-254">
              Get The Complete System Now
            </a>
          </div>
        </div>
      </div>
    </section>;
}
export function Guarantee() {
  return <section className="py-24 px-6 bg-cream text-navy-900" data-id="element-255">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-256">
        <div className="w-24 h-24 mx-auto bg-gold-500 rounded-full flex items-center justify-center shadow-xl mb-8" data-id="element-257">
          <ShieldCheck className="w-12 h-12 text-cream" data-id="element-258" />
        </div>

        <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy-900" data-id="element-259">
          The "Sleep Through The Night Or It's Free" Guarantee
        </h2>

        <div className="max-w-2xl mx-auto space-y-6 text-lg text-navy-800/80 font-medium" data-id="element-260">
          <p data-id="element-261">Here's my promise to you:</p>
          <p data-id="element-262">Follow the 11PM Spine Reset protocol for 60 full nights.</p>
          <p className="text-xl font-serif text-navy-900 italic" data-id="element-263">
            If you don't experience a measurable reduction in nighttime back
            pain — if you're not sleeping better, moving easier, and waking up
            without that familiar dread —
          </p>
          <p className="font-bold text-navy-900" data-id="element-264">
            Email us. Get every penny back.
          </p>
          <p data-id="element-265">No questions. No forms to fill out. No hoops to jump through.</p>
          <p data-id="element-266">
            I'm not asking you to trust me. I'm asking you to trust the science.
          </p>
          <p className="text-xl font-bold text-teal-600" data-id="element-267">
            Try it. Feel it work. Then decide.
          </p>
        </div>
      </div>
    </section>;
}
export function Urgency() {
  return <section className="py-16 px-6 bg-navy-900 border-b border-navy-800 text-center" data-id="element-268">
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-269">
        <p className="text-teal-400 font-bold uppercase tracking-widest text-sm" data-id="element-270">
          A note on pricing
        </p>
        <p className="text-xl text-cream-300/90" data-id="element-271">
          This guide is currently available at the introductory launch price of
          $6.39. <br data-id="element-272" />
          <span className="font-bold text-cream" data-id="element-273">
            This price will not stay here.
          </span>
        </p>
        <p className="text-cream-300/70" data-id="element-274">
          The people who move today get the best deal. The people who wait get
          the higher price and another night of broken sleep.
        </p>
      </div>
    </section>;
}